<template>
  <div class="offersHeader__Sticker" :class="{'offersHeader__Sticker--Narrow': daysLeft && daysLeft > 0, 'offersHeader__Sticker--Expired': timeOfferExpired}">
    <ClientOnly>
      <p v-if="!timeOfferExpired">
        <span v-if="item.text_above_counter">{{ item.text_above_counter }}</span>
        <strong>{{ timerValue }}</strong>
        <span v-if="daysLeft && daysLeft > 0">{{ $t('offerGroupDetail.days', daysLeft) }}</span>
      </p>
      <p v-else>
        <span>{{ $t('offerGroupDetail.offerExpired') }}</span>
      </p>
    </ClientOnly>
  </div>
</template>

<script setup>
  const props = defineProps({
    item: {
      type: Object,
      default: {},
    },
  });

  const today = ref(Date.now());
  const timeOfferExpired = ref(false);
  const timerValue = ref('0');
  const SECOND_IN_MILLISECONDS = 1000;
  const MINUTE_IN_MILLISECONDS = SECOND_IN_MILLISECONDS * 60;
  const HOUR_IN_MILLISECONDS = MINUTE_IN_MILLISECONDS * 60;
  const DAY_IN_MILLISECONDS = HOUR_IN_MILLISECONDS * 24;

  const daysLeft = ref(0);
  let countdownTo = new Date(props.item.expiration).getTime();

  function countdown() {
    const currentTime = performance.now();
    const timeLeft = countdownTo - today.value - currentTime;

    if (timeLeft < 0) {
      timeOfferExpired.value = true;
      return;
    }

    daysLeft.value = Math.floor(timeLeft / DAY_IN_MILLISECONDS);
    const hoursLeft = Math.floor(
      (timeLeft % DAY_IN_MILLISECONDS) / HOUR_IN_MILLISECONDS
    ).toLocaleString('en-US', { minimumIntegerDigits: 2 });
    const minutesLeft = Math.floor(
      (timeLeft % HOUR_IN_MILLISECONDS) / MINUTE_IN_MILLISECONDS
    ).toLocaleString('en-US', { minimumIntegerDigits: 2 });
    const secondsLeft = Math.floor(
      (timeLeft % MINUTE_IN_MILLISECONDS) / SECOND_IN_MILLISECONDS
    ).toLocaleString('en-US', { minimumIntegerDigits: 2 });

    if(daysLeft.value && daysLeft.value > 0) {
      timerValue.value = `${daysLeft.value}`;
    }
    else {
      timerValue.value = `${hoursLeft}:${minutesLeft}:${secondsLeft}`;
    }

    requestAnimationFrame(countdown);
  }

  onMounted(() => {
    requestAnimationFrame(countdown);
  });
</script>